import {FC, useCallback, useState} from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import {useAuth} from "../lib/auth.ts";
import {Checkbox, FormControlLabel} from "@mui/material";
import Form from "@memaro/components/Form.tsx";
import {useFormCheckbox} from "@memaro/forms";
import {styled} from "@mui/material/styles";
import Stack from "@mui/material/Stack";

const StyledStack = styled(Stack)({
    width: 'fit-content',
    margin: '0 auto'
})

const AcceptTermsPage: FC = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const {updateUserAttributes} = useAuth()

    const [acceptedTerms, setAcceptedTerms] = useFormCheckbox()
    const [acceptedPrivacy, setAcceptedPrivacy] = useFormCheckbox()

    const handleAccept = useCallback(() => {
        setLoading(true)
        updateUserAttributes({acceptedTerms: true}).finally(() => setLoading(false))
    }, [updateUserAttributes])

    return (
        <StyledStack>
            <h1>Algemene voorwaarden</h1>
            <p>
                Om toegang te krijgen tot het Memaro platform, moet je eerst akkoord gaan met de algemene
                voorwaarden en de privacy verklaring.
                Deze documenten bevatten belangrijke informatie over hoe we jouw gegevens gebruiken en welke
                verantwoordelijkheden je hebt als gebruiker van onze applicatie. We raden je aan om deze documenten
                zorgvuldig door te lezen voordat je akkoord gaat.
            </p>
            <Form>
                <FormControlLabel
                    control={<Checkbox onChange={setAcceptedTerms} checked={acceptedTerms}/>}
                    label={<>Ik ga akkoord met de <a href="#" target="_blank">algemene voorwaarden</a></>}
                    required
                />
                <FormControlLabel
                    control={<Checkbox onChange={setAcceptedPrivacy} checked={acceptedPrivacy}/>}
                    label={<>Ik ga akkoord met de <a href="#" target="_blank">privacy verklaring</a></>}
                    required
                />
                <Button onClick={handleAccept} loading={loading} disabled={!acceptedTerms || !acceptedPrivacy} color="primary">
                    <AddIcon/>
                    Accepteren
                </Button>
            </Form>
        </StyledStack>
    )
}

export default AcceptTermsPage
